import { Helmet } from "react-helmet";
import {
    Box,
    ClickAwayListener,
    Stack,
    MenuItem,
    MenuList,
    Divider,
    InputAdornment,
    TextField,
    Tab,
    Tabs,
    Select,
    Container,
    Grid,
    Typography,
    Button,
    usePagination,
    Grow,
    Popper,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Paper,
    Avatar
} from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import DatePicker from '@mui/lab/DatePicker';
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import AccessibleIcon from "@mui/icons-material/Accessible";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Search from "@mui/icons-material/Search";
import React, { useEffect, useMemo } from "react";
import { DropResult, DragDropContext, Droppable, OnDragEndResponder, Draggable } from 'react-beautiful-dnd';
import DraggableList from '../DraggableList';
import competencyService from "../../../../services/competency.service";
import cssVariables from "../../../../theme/cssVariables";
import { styled } from "@mui/styles";
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg";
import { ReactComponent as ChevronExpandDown } from "../../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../../../assets/icons/chevron-expand-up.svg";
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as Calendar } from "../../../../assets/icons/calendar.svg";
import { ReactComponent as FilterStatus } from "../../../../assets/icons/filter-status.svg";
import { ReactComponent as IconImport } from "../../../../assets/icons/import.svg";
import { ReactComponent as Doner } from "../../../../assets/icons/doner.svg";
import { ReactComponent as XIcon } from "../../../../assets/icons/xIcon.svg";
import { ReactComponent as LaunchFormIcon } from "../../../../assets/icons/launchForm.svg";
import { ReactComponent as Restart } from "../../../../assets/icons/restart.svg";
import exports from "../../../../assets/images/export.png";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import * as Util from "../../../../services/global.service";
import adminService from "../../../../services/admin.service";
import { useSelector, useDispatch } from "react-redux";
import { listGoalLibraryGoalItem, listGoalLibraryGoalItemByGroup } from "../../../../actions/admin";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import calibrationService from "../../../../services/calibration.service";
import { listCycle } from "../../../../actions/admin";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "5px!important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        },

    });
    const classes = useStyles();
    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                            children = (
                                <Button
                                    {...item}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {page}
                                </Button>
                            );
                        } else if (type === "first" || type === "last") {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                                </Button>
                            );
                        } else {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    variant="outlined"
                                    classes={{
                                        root: classes.paginationRoot,
                                    }}
                                >
                                    {type === "previous"
                                        ? `${t('label.previous')}`
                                        : type === "next"
                                            ? `${t('label.next')}`
                                            : ""}
                                </Button>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}

const useStyles = makeStyles({
    dateTimePicker: {
        display: "flex !important",
        flexDirection: "column !important",
        justifyContent: "space-between !important",
        position: "relative",
        marginBottom: "14px !important",

    },
    plusSvg: {
        "& > path": {
            fill: "#fff",
            stroke: "#fff",
        },
    },
    input: {
        '& div > input': {
            height: '7px',
            position: "relative"
        }
    },
    draggingListItem: {
        background: 'rgb(235,235,235)'
    },
    toggleBtnRoot: {
        background: `transparent !important`,
        color: "#6B6B6B !important",
        width: "320px",
        border: "none !important",
    },
    toggleBtnSelected: {
        background: `${cssVariables.color.primary}!important`,
        color: "#fff!important",
    },
    flexPaper: {
        flex: 1,
        minWidth: 350,
        "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        "border-radius": "10px !important        "
    },
    tab: {
        fontSize: "16px !important",
        fontWeight: "300 !important",
        // color: "#A3A3A3 !important",
        '&.Mui-selected': {
            color: cssVariables.color.primary + " !important"
        }
    },
    root: {
        display: 'flex',
        width: "100%",
        flexWrap: 'wrap'
    }
});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const CalibrationSession = () => {
    let { serial, page } = useParams()
    const [items, setItems] = React.useState([]);
    const [mainItems, setMainItems] = React.useState([]);
    const classes = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const [code, setCode] = React.useState("");
    const [name, setName] = React.useState("");
    const [status, setStatus] = React.useState("all");
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [updatedBy, setUpdatedBy] = React.useState("");
    const [searchProgress, setSearchValueProgress] = React.useState("");
    const [perPage, setPerPage] = React.useState(10);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);
    const [openAdvanceFilters, setOpenAdvanceFilters] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [draft, setDraft] = React.useState(true);
    const [inProgress, setInProgress] = React.useState(true);
    const [pending, setPending] = React.useState(true);
    const [completed, setCompleted] = React.useState(true);
    const [deleted, setDeleted] = React.useState(true);
    const [submit, setSunmit] = React.useState(false);
    const [allow_adjust, setAllow_adjust] = React.useState(true);
    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [isSuccessLaunchFor, openSuccessLaunchFor] = React.useState(false);
    const [isConfirmLaunchFormDialogOpen, setConfirmLaunchFormDialogOpen] = React.useState(false);
    const [isRestartDialogOpen, setConfirmRestartDialogOpen] = React.useState(false);
    const [dataRestart, setDataRestart] = React.useState([]);
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const [openFailedLaunchMessageDialog, setFailedLaunchMessageDialog] = React.useState(false);
    const [competencyFormSelect, setCompetencyForm] = React.useState([]);
    const [competencyFormSelectValue, setCompetencyFormValue] = React.useState("");
    const [openLaunchForm, setOpenLaunchForm] = React.useState(false);
    const [selected, setSelected] = React.useState([]);
    let language = localStorage.getItem("lang");

    let closeLaunchForm = () => {
        setOpenLaunchForm(false)
    }

    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }));
    const handleCancel = () => {
        setCode("")
        setName("")
        setStatus("all")
        setStartDate(null)
        setEndDate(null)
        setUpdatedBy("")
        setOpenAdvanceFilters(false)
    }
    useEffect(() => {
        getList()
    }, [competencyFormSelectValue]);
    let getList = () => {
        calibrationService.getListCalibrationSession(competencyFormSelectValue).then(resp => {
            let dataList = Util.formatData(resp?.data?.calibration_session, [])
            setMainItems(dataList)
            // dataSerachs(dataList)
        })
    }
    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }
    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };
    const filterActiveSerach = (data) => {
        let result = []
        let dataFilter = JSON.parse(JSON.stringify(data))
        if (draft === false && inProgress === false && pending === false && completed === false && deleted === false) {
            setItems(result)
        } else if (draft === true && inProgress === true && pending === true && completed === true && deleted === true) {
            setItems(data)
        } else {
            let resultData = dataFilter
            resultData = dataFilter.filter(rs => {
                return ((draft && rs?.status === "draft") || (inProgress && rs?.status === "in_progress") || (pending && rs?.status === "pending") || (deleted && rs?.status === "deleted") || (completed && (rs?.status === "completed" || rs?.status === "approved")))
            })

            /*
            if (draft) resultData = dataFilter.filter(rs => rs?.status === "draft");
            if (inProgress) resultData = dataFilter.filter(rs => rs?.status === "in_progress");
            if (pending) resultData = dataFilter.filter(rs => rs?.status === "pending");
            if (completed) resultData = dataFilter.filter(rs => rs?.status === "completed" || rs?.status === "approved");
            if (deleted) resultData = dataFilter.filter(rs => rs?.status === "deleted");
            */

            /*
            if (draft === true && inProgress === false && pending === false && completed === false && deleted === false) {
                let resultData = dataFilter.filter(rs => rs?.status === "draft");
                result = resultData
                setItems(result)
            } else if (inProgress === true) {
                let resultData = dataFilter.filter(rs => rs?.status === "in_progress");
                result = resultData
                setItems(result)
            } else if (pending === true) {
                let resultData = dataFilter.filter(rs => rs?.status === "pending");
                result = resultData
                setItems(result)
            } else if (completed === true) {
                let resultData = dataFilter.filter(rs => rs?.status === "completed" || rs?.status === "approved");
                result = resultData
                setItems(result)
            } else if (deleted === true) {
                let resultData = dataFilter.filter(rs => rs?.status === "deleted");
                result = resultData
                setItems(result)
            }
            */
            setItems(resultData)
        }
    };

    const EditNotActive = (data) => {
        if (data === "draft") {
            setDraft(!draft)
        } else if (data === "in_progress") {
            setInProgress(!inProgress)
        } else if (data === "pending") {
            setPending(!pending)
        } else if (data === "completed" || data === "approved") {
            setCompleted(!completed)
        } else if (data === "deleted") {
            setDeleted(!deleted)
        } else if (data === "selectAll") {
            if (draft === true && inProgress === true && pending === true && completed === true && deleted === true) {
                setDraft(false)
                setInProgress(false)
                setPending(false)
                setCompleted(false)
                setDeleted(false)
            } else if (draft === false && inProgress === false && pending === false && completed === false && deleted === false) {
                setDraft(true)
                setInProgress(true)
                setPending(true)
                setCompleted(true)
                setDeleted(true)
            } else if (draft === true || inProgress === true || pending === true || completed === true || deleted === true) {
                setDraft(true)
                setInProgress(true)
                setPending(true)
                setCompleted(true)
                setDeleted(true)
            }
        }
    };
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleSearchProgress = (event) => {
        setSearchValueProgress(event.target.value);
    };

    const currentData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return items
            .slice(firstPageIndex, lastPageIndex);
    }, [items, currentPage, perPage]);
    const handleTotalPage = () => {
        const List = items
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };
    useEffect(() => {
        handleTotalPage();
    }, [items, perPage]);

    useEffect(() => {
        let update = checkResired
        if (Object.keys(checkResired)[0] !== undefined) {
            if (update[Object.keys(checkResired)[0]] === false) {
                currentData.sort(function (b, a) {
                    if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                        return -1;
                    }
                    if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                        return 1;
                    }
                    return 0;
                });
                setreSet(!reSet)
            } else if (update[Object.keys(checkResired)[0]] === true) {
                currentData.sort(function (a, b) {
                    if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                        return -1;
                    }
                    if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                        return 1;
                    }
                    return 0;
                });
                setreSet(!reSet)
            }
        }
    }, [currentData]);
    useEffect(() => {
        dataSerachs(mainItems)
    }, [searchProgress]);
    useEffect(() => {
        dataSerachs(mainItems)
    }, [mainItems, draft, inProgress, pending, completed, deleted]);
    useEffect(() => {
        getDataCompetencyYear();
    }, []);

    let getDataCompetencyYear = () => {
        dispatch(listCycle()).then(
            (response) => {
                let cycle_list = (response.data.cycle ?? []).filter((c) => c.is_probation === false)

                setCompetencyForm(cycle_list)
                console.log(cycle_list);
                if (cycle_list !== undefined && cycle_list.length > 0) {
                    let filterData = cycle_list.filter((e) => e.is_current === true)
                    if (Util.formatData(state?.cycleID, false) !== false) {
                        setCompetencyFormValue(state?.cycleID)
                    } else if (filterData.length > 0) {
                        setCompetencyFormValue(filterData[0].serial)
                        // setAllow_adjust(filterData[0]?.options?.allow_adjust)
                    } else {
                        setCompetencyFormValue(cycle_list[0].serial)
                        // setAllow_adjust(response.data.cycle[0]?.options?.allow_adjust)
                    }
                }
            },
        );
    }
    const handleChangeWorkloadForm = (event) => {
        setCompetencyFormValue(event.target.value);
    };
    const dataSerachs = async (data) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(data))
        if (searchProgress !== "" && dataSerach !== undefined && dataSerach.length > 0) {
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs).some(key => {
                    if (key === 'code' || key === 'name') {
                        return rs[key].toString().toLowerCase().indexOf(searchProgress.toString().toLowerCase()) !== -1;
                    }
                    if (key === 'options') {
                        let checkName = false;
                        if (rs[key].name_en !== undefined && rs[key].name_en.toString().toLowerCase().indexOf(searchProgress.toString().toLowerCase()) !== -1) {
                            checkName = true;
                        }
                        if (rs[key].name_th !== undefined && rs[key].name_th.toString().toLowerCase().indexOf(searchProgress.toString().toLowerCase()) !== -1) {
                            checkName = true;
                        }
                        return checkName;
                    }
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        await filterActiveSerach(result);
    };

    const clickLink = (data) => {
        navigate(data, { replace: false });
    }

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };
    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };
    const toTimestamp = (strDate) => {
        if (strDate !== "" && strDate !== null && strDate !== undefined) {
            const dt = Date.parse(strDate);
            return dt / 1000;
        } else {
            return 0;
        }
    }
    let sortData = (key, check1) => {
        let update = checkResired
        if (check1 === false && update[key] !== check1) {
            if (key === "created_by" || key === "updated_by") {
                currentData.sort(function (b, a) {
                    if (Util.formatData(a[key]?.fullname, "") > Util.formatData(b[key]?.fullname, "")) {
                        return -1;
                    }
                    if (Util.formatData(b[key]?.fullname, "") > Util.formatData(a[key]?.fullname, "")) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                currentData.sort(function (b, a) {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                    return 0;
                });
            }
            update = { [key]: false }
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            if (key === "created_by" || key === "updated_by") {
                currentData.sort(function (a, b) {
                    if (Util.formatData(a[key]?.fullname, "") > Util.formatData(b[key]?.fullname, "")) {
                        return -1;
                    }
                    if (Util.formatData(b[key]?.fullname, "") > Util.formatData(a[key]?.fullname, "")) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                currentData.sort(function (a, b) {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                    return 0;
                });
            }
            update = { [key]: true }
            setCheckRsquired(update)
            setreSet(!reSet)
        }
    }
    const onScroll = (evt) => {
        if (evt !== undefined && evt !== null) {
            if (open) {
                setOpen(false)
            }
        }
    }
    const onOpenAdvanceFilters = () => {
        setOpenAdvanceFilters(!openAdvanceFilters)
    }
    const onCheckCode = (val) => {
        setCode(val)
    }
    const onCheckName = (val) => {
        setName(val)
    }
    const onCheckStatus = (val) => {
        setStatus(val)
    }
    const onCheckStartDate = (val) => {
        setStartDate(Util.formatDate(val))
    }
    const onCheckEndDate = (val) => {
        setEndDate(Util.formatDate(val))
    }
    const onCheckUpdatedBy = (val) => {
        setUpdatedBy(val)
    }
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const handleOpenFailedLaunchMessageDialog = (value) => {
        setFailedLaunchMessageDialog(true);
    };
    const handleCloseFailedLaunchMessageDialog = (value) => {
        setFailedLaunchMessageDialog(false);
    };
    // const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
    const [itemDel, setItemDel] = React.useState("");
    const [nameDel, setNameDel] = React.useState("");
    const handleConfirmDeleteDialog = (val, serial) => {
        if (val === false) {
            setItemDel("")
        }
        openConfirmDeleteDialog(val);
    };
    const handleDeleteClick = React.useCallback((e, data, name) => {
        e.stopPropagation();
        e.preventDefault();
        setItemDel(data)
        handleConfirmDeleteDialog(true, data)
        setNameDel(name)
    }, []);
    const handleClick = (data) => {
        const selectedIndex = selected.indexOf(data);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, data);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };
    const handleClickAll = () => {
        if (checkAll() === true) {
            setSelected([]);
        } else {
            let dtFilter = mainItems.filter((rs) => rs?.status === "draft")
            if (dtFilter.length > 0) {
                dtFilter = dtFilter.map((res) => res?.serial)
            }
            setSelected(dtFilter);
        }
    };

    let checkAll = () => {
        let selectAll = true
        if (mainItems.length > 0) {
            let dtFilter = mainItems.filter((rs) => rs?.status === "draft")
            if (dtFilter.length === 0 || dtFilter.length !== selected.length) {
                selectAll = false
            }
        } else {
            selectAll = false
        }
        return selectAll
    }

    let checkIndeterminate = () => {
        if (selected.length > 0) {
            let dtFilter = mainItems.filter((rs) => rs?.status === "draft")
            if (dtFilter.length > 0 && selected.length > 0 && dtFilter.length !== selected.length) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }
    let checkSelect = (data) => {
        let check = false
        let checkFilterData = selected.filter((rs) => rs === data)
        if (checkFilterData.length > 0) {
            check = true
        }
        return check
    }
    let onCancel = () => {
        setDraft(true);
        setInProgress(true);
        setPending(true);
        setCompleted(true);
        setDeleted(true);
        setOpenLaunchForm(false)
        setSelected([])
    }
    let onLaunchForm = () => {
        setDraft(true);
        setInProgress(false);
        setPending(false);
        setCompleted(false);
        setDeleted(false);
        setOpenLaunchForm(true)
        setSelected([])
    }
    let launchForm = () => {
        let data = {
            calibration_session_id: selected
        }
        calibrationService.launchCalibrationSession(data).then(resp => {
            openSuccessLaunchFor(true)
        }).catch((err) => {
            handleOpenFailedMessageDialog(true)
        })
    }
    let reStartForm = () => {
        let data = {
            calibration_session_id: dataRestart
        }
        calibrationService.reStartCalibrationSession(data).then(resp => {
            closeReStartSuccess(true)
        }).catch((err) => {
        })
        setConfirmRestartDialogOpen(false)
    }
    let closeReStartSuccess = () => {
        onCancel()
        getList()
        // openSuccessLaunchFor(false)
    }
    let closeSuccess = () => {
        onCancel()
        getList()
        openSuccessLaunchFor(false)
        setConfirmLaunchFormDialogOpen(false)
    }
    const handleConfirmDeleteList = () => {
        calibrationService.deleteCalibrationSession(itemDel).then(
            (response) => {
                openConfirmDeleteDialog(false)
                getList()
                openSuccessDeleteDialog(true)
            },
        ).catch(() => {
            openConfirmDeleteDialog(false)
            handleOpenFailedMessageDialog()
        })
    };

    let openConfirmRestart = (data) => {
        setDataRestart([data])
        setConfirmRestartDialogOpen(true)
    }
    return (
        <Box onScroll={onScroll} style={{ "max-height": "100%", "overflow-y": "auto" }}>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.end} >{t('admin.label.calibrationSession')}</span></Typography>
                    </Grid>
                    <Grid container item >
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} pt="7px">
                            <Typography variant="h2" color="#404349" fontWeight="600" fontSize={36} lineHeight="40px" >
                                {t('admin.label.calibrationSession')}
                            </Typography>
                            {competencyFormSelect.length > 0 ?
                                <Box
                                    display="flex"
                                    alignItems="flex-start"
                                    justifyContent="flex-start"
                                    flexDirection="row"
                                >
                                    <Select
                                        id="workload-select"
                                        inputlabelprops={{ shrink: false }}
                                        variant="outlined"
                                        size="small"
                                        sx={{ width: "400px" }}
                                        className="white-bg"
                                        value={competencyFormSelectValue}
                                        onChange={handleChangeWorkloadForm}
                                    >
                                        {
                                            competencyFormSelect?.length > 0 ?
                                                competencyFormSelect.map(item => {
                                                    return (
                                                        <MenuItem value={item.serial} key={item.serial}>
                                                            {item.name}
                                                        </MenuItem>
                                                    )
                                                })

                                                : <MenuItem value="">
                                                    ---{t('label.notFund')}---
                                                </MenuItem>
                                        }
                                    </Select>
                                </Box>
                                : null}
                        </Box>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid container item sx={{ height: "100%" }}>
                            <Box sx={{ width: "100%" }}>
                                <Box pt="30px" pb="30px" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <TextField
                                            id="input-with-icon-textfield"
                                            fullWidth
                                            placeholder={t('admin.label.search')}
                                            size="small"
                                            sx={{ background: "#fff", width: "400px", "input": { padding: "11px 14px" } }}
                                            className="searchTextField-h40"
                                            value={searchProgress}
                                            onChange={handleSearchProgress}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search style={{ color: "#C4C4C4" }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Box>
                                    {openLaunchForm ?
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <Button
                                                size="small"
                                                aria-controls="simple-menu"
                                                aria-haspopup="true"
                                                onClick={() => onCancel()}
                                                color="red"
                                                variant="contained"
                                                sx={{ width: "103px", height: "45px", p: "0", textTransform: "none", "margin-left": "30px" }}
                                            // disabled={allow_adjust === true ? false : true}
                                            >
                                                <XIcon className={classes.plusSvg} />
                                                <Typography sx={{ textTransform: "none" }} pl="10px" fontSize={18} lineHeight="26.91px" fontWeight="500" color="#FFFFFF">{t("label.cancel")}</Typography>
                                            </Button>
                                            <Button
                                                size="small"
                                                aria-controls="simple-menu"
                                                aria-haspopup="true"
                                                onClick={e => setConfirmLaunchFormDialogOpen(true)}
                                                disabled={selected.length === 0}
                                                color="primary"
                                                variant="contained"
                                                sx={{ width: "103px", height: "45px", p: "0", textTransform: "none", "margin-left": "30px" }}
                                            >
                                                <LaunchFormIcon />
                                                <Typography sx={{ textTransform: "none" }} pl="10px" fontSize={18} lineHeight="26.91px" fontWeight="500" color="#FFFFFF">{t("label.launch")}</Typography>
                                            </Button>
                                        </Box>
                                        :
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <Button
                                                size="small"
                                                aria-controls="simple-menu"
                                                aria-haspopup="true"
                                                onClick={() => clickLink(`/admin/calibration-session/create/${competencyFormSelectValue}`)}
                                                color="black"
                                                variant="contained"
                                                sx={{ width: "103px", height: "45px", p: "0", textTransform: "none", "margin-left": "30px" }}
                                            // disabled={allow_adjust === true ? false : true}
                                            >
                                                <PlusIcon className={classes.plusSvg} />
                                                <Typography sx={{ textTransform: "none" }} pl="10px" fontSize={18} lineHeight="26.91px" fontWeight="500" color="#FFFFFF">{t("label.create")}</Typography>
                                            </Button>
                                            <Button
                                                size="small"
                                                aria-controls="simple-menu"
                                                aria-haspopup="true"
                                                onClick={e => onLaunchForm()}
                                                color="primary"
                                                variant="contained"
                                                sx={{ width: "103px", height: "45px", p: "0", textTransform: "none", "margin-left": "30px" }}
                                            >
                                                <LaunchFormIcon />
                                                <Typography sx={{ textTransform: "none" }} pl="10px" fontSize={18} lineHeight="26.91px" fontWeight="500" color="#FFFFFF">{t("label.launch")}</Typography>
                                            </Button>
                                        </Box>
                                    }
                                </Box>
                            </Box>
                            <div className={classes.root}>
                                <Paper className={classes.flexPaper} >
                                    <Box
                                        px="40px"
                                    >
                                        <Box
                                            px="25px"
                                            py="19px"
                                            sx={{ display: "flex", "flex-direction": "row" }}
                                        >
                                            {openLaunchForm ?
                                                <Box width="59px">
                                                    <Checkbox
                                                        onClick={(event) => handleClickAll()}
                                                        sx={{ margin: "0 35px 0 0", padding: "0", alignItems: "center" }}
                                                        indeterminate={checkIndeterminate()}
                                                        checked={checkAll()}
                                                    />
                                                </Box>
                                                : null}
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(8% - 10px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('admin.inputForm.code')}
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("code", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("code", false)} />
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: openLaunchForm ? "calc(17% - 21.8px)" : "calc(17% - 10px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('label.name')}
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: openLaunchForm ? "calc(22.2% - 21.8px)" : "calc(22.2% - 10px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('admin.label.calibrator')}
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(8% - 10px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", }}>
                                                    {t('label.employee')}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", justifyContent: "center", width: openLaunchForm ? "calc(14.2% - 21.8px)" : "calc(14.2% - 10px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('label.formStatus')}
                                                </Typography>
                                                {openLaunchForm === false ?
                                                    <Stack direction="row" spacing={2}>
                                                        <div>
                                                            <FilterStatus
                                                                ref={anchorRef}
                                                                id="composition-button"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={handleToggle}
                                                            />
                                                            <Popper
                                                                open={open}
                                                                anchorEl={anchorRef.current}
                                                                role={undefined}
                                                                placement="bottom-start"
                                                                transition
                                                                disablePortal
                                                                style={{ "z-index": "1" }}
                                                            >
                                                                {({ TransitionProps, placement }) => (
                                                                    <Grow
                                                                        {...TransitionProps}
                                                                        style={{
                                                                            transformOrigin:
                                                                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                                        }}
                                                                    >
                                                                        <Paper sx={{ "margin-top": "5px !important" }}>
                                                                            <ClickAwayListener onClickAway={handleClose}>
                                                                                <MenuList
                                                                                    autoFocusItem={open}
                                                                                    id="composition-menu"
                                                                                    aria-labelledby="composition-button"
                                                                                    onKeyDown={handleListKeyDown}
                                                                                >

                                                                                    <Box px="16px" py="6px">
                                                                                        <FormGroup>
                                                                                            <FormControlLabel control={<Checkbox indeterminate={draft === true || inProgress === true || pending === true || completed === true || deleted === true ? draft === false || inProgress === false || pending === false || completed === false || deleted === false : false} onChange={e => EditNotActive("selectAll")} checked={draft === true && inProgress === true && pending === true && completed === true && deleted === true} />} label={t('competency.selectAll')} />
                                                                                            <FormControlLabel control={<Checkbox onChange={e => EditNotActive("draft")} checked={draft} />} label={t('label.draft')} />
                                                                                            <FormControlLabel control={<Checkbox onChange={e => EditNotActive("in_progress")} checked={inProgress} />} label={t('label.inProgress')} />
                                                                                            <FormControlLabel control={<Checkbox onChange={e => EditNotActive("pending")} checked={pending} />} label={t('label.pending')} />
                                                                                            <FormControlLabel control={<Checkbox onChange={e => EditNotActive("completed")} checked={completed} />} label={t('label.completed')} />
                                                                                            {/* <FormControlLabel control={<Checkbox onChange={e => EditNotActive("deleted")} checked={deleted} />} label={t('label.deleted')} /> */}
                                                                                        </FormGroup>
                                                                                    </Box>
                                                                                </MenuList>
                                                                            </ClickAwayListener>
                                                                        </Paper>
                                                                    </Grow>
                                                                )}
                                                            </Popper>
                                                        </div>
                                                    </Stack>
                                                    : null}
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: openLaunchForm ? "calc(15.3% - 21.8px)" : "calc(15.3% - 25px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('admin.label.createdBy')}
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("created_by", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("created_by", false)} />
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: openLaunchForm ? "calc(15.3% - 21.8px)" : "calc(15.3% - 25px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('admin.label.updatedBy')}
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("updated_by", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("updated_by", false)} />
                                                </Typography>
                                            </Box>
                                            {openLaunchForm ?
                                                null
                                                :
                                                <Box sx={{ display: "flex", "flex-direction": "row", width: "100px" }}>
                                                    <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                        {t('admin.label.action')}
                                                    </Typography>
                                                </Box>
                                            }
                                        </Box>
                                        <Divider width="100%" />
                                    </Box>
                                    {currentData !== undefined && currentData !== null && currentData.length > 0 ? currentData.map((row, index) => (
                                        <Box px="40px">
                                            <Box sx={{ width: "100%", position: "relative", "&:before": { content: '""', position: 'absolute', height: row?.status === "deleted" ? "100%" : "0px", width: row?.status === "deleted" ? "100%" : "0px", top: "0", background: "#FAFAFA", opacity: "0.7" }, }}>
                                                <Box
                                                    sx={{ height: "96px", background: "#FFF", width: "100%", display: "flex", "align-items": "center" }}
                                                    px="25px"
                                                >
                                                    {openLaunchForm ?
                                                        <Box width="59px">
                                                            <Checkbox
                                                                onClick={(event) => handleClick(row?.serial)}
                                                                sx={{ margin: "0 35px 0 0", padding: "0", alignItems: "center" }}
                                                                // onChange={e => changeType(data?.serial)} 
                                                                checked={checkSelect(row?.serial)}
                                                            />
                                                        </Box>
                                                        : null}
                                                    <Box sx={{ width: "calc(8% - 10px)" }} pr="15px">
                                                        <Typography fontSize={16} color="#404349" lineHeight="23.96px" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {`${row?.code}`}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ width: openLaunchForm ? "calc(17% - 21.8px)" : "calc(17% - 1.8px)", display: "flex", justifyContent: "flex-start", alignItems: "center" }} pr="15px">
                                                        <Typography pb={row?.options?.name_th !== null && row?.options?.name_th !== undefined && row?.options?.name_th !== "" ? "0" : "5px"} fontWeight="500" fontSize={16} lineHeight="26.91px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {row?.options?.name_en !== undefined && row?.options?.name_en !== null ? row?.options?.name_en : row?.name}
                                                        </Typography>
                                                        {/* {row?.options?.name_th !== null && row?.options?.name_th !== undefined && row?.options?.name_th !== "" ?
                                                            <Typography fontWeight="400" fontSize={14} lineHeight="20.93px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                {row?.options?.name_th}
                                                            </Typography>
                                                            :
                                                            null
                                                        } */}
                                                    </Box>
                                                    <Box sx={{ width: openLaunchForm ? "calc(22.2% - 21.8px)" : "calc(22.2% - 10px)", display: "flex", justifyContent: "flex-start", alignItems: "center" }} pr="15px">
                                                        <Avatar
                                                            src={Util.formatData(row?.calibration_session_role?.calibrator?.employee?.photo, "")}
                                                            sx={{
                                                                cursor: "pointer",
                                                                width: 40,
                                                                height: 40,
                                                            }}
                                                        />
                                                        <Box ml={(2)} sx={{ width: "calc(100% - 45px)" }}>
                                                            <Typography pb={row?.calibration_session_role?.calibrator?.employee?.options?.name_th !== null && row?.calibration_session_role?.calibrator?.employee?.options?.name_th !== undefined && row?.calibration_session_role?.calibrator?.employee?.options?.name_th !== "" ? "0" : "5px"} fontWeight="500" fontSize={16} lineHeight="26.91px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                {row?.calibration_session_role?.calibrator?.employee?.options?.name_en !== undefined && row?.calibration_session_role?.calibrator?.employee?.options?.name_en !== null ? Util.formatData(row?.calibration_session_role?.calibrator?.employee?.options?.name_en, "") : Util.formatData(row?.calibration_session_role?.calibrator?.employee?.fullname, "")}
                                                            </Typography>
                                                            {row?.calibration_session_role?.calibrator?.employee?.options?.name_th !== null && row?.calibration_session_role?.calibrator?.employee?.options?.name_th !== undefined && row?.calibration_session_role?.calibrator?.employee?.options?.name_th !== "" ?
                                                                <Typography fontWeight="400" fontSize={14} lineHeight="20.93px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                    {row?.calibration_session_role?.calibrator?.employee?.options?.name_th}
                                                                </Typography>
                                                                :
                                                                null
                                                            }
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ width: "calc(8% - 10px)", textAlign: "center" }} pr="15px">
                                                        <Typography fontSize={16} color="#404349" lineHeight="23.96px" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {row?.options?.total_employee}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ width: openLaunchForm ? "calc(14.2% - 21.8px)" : "calc(14.2% - 10px)", display: "flex", justifyContent: "center" }} pr="15px">
                                                        <Box py="8px" px="20px" sx={{ "max-width": "100%", width: "max-content", border: row?.status === "draft" ? "1px solid #DADADA" : "none", "border-radius": "5px", background: row?.status === "in_progress" ? "#EFB76D1A" : row?.status === "pending" ? "#FEF3EA" : row?.status === "completed" || row?.status === "approved" ? "#5DA1961A" : row?.status === "deleted" ? "#8282821A" : "none" }} >
                                                            <Typography fontSize={16} lineHeight="24px" fontWeight={500} color={row?.status === "in_progress" ? "#EFB76D" : row?.status === "pending" ? "#F28026" : row?.status === "completed" || row?.status === "approved" ? "#5DA196" : row?.status === "deleted" ? "#828282" : "#6B6B6B"} sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                {row?.status_name}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ display: "flex", "flex-direction": "column", width: openLaunchForm ? "calc(15.3% - 21.8px)" : "calc(15.3% - 25px)" }} pr="15px">
                                                        <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {row?.created_by?.fullname !== undefined && row?.created_by?.fullname !== null ? row?.created_by?.fullname : row?.created_at !== undefined && row?.created_at !== null && row?.created_at !== "" ? "Default" : ""}
                                                        </Typography>
                                                        <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {Util.dateDayTimeFormatAdmin(row?.created_at)}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ display: "flex", "flex-direction": "column", width: openLaunchForm ? "calc(15.3% - 21.8px)" : "calc(15.3% - 25px)" }} pr="15px">
                                                        <Typography fontWeight="400" fontSize={16} color="#404349" lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {row?.updated_by?.fullname !== undefined && row?.updated_by?.fullname !== null ? row?.updated_by?.fullname : row?.updated_at !== undefined && row?.updated_at !== null && row?.updated_at !== "" ? "Default" : ""}
                                                        </Typography>
                                                        <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {Util.dateDayTimeFormatAdmin(row?.updated_at)}
                                                        </Typography>
                                                    </Box>
                                                    {openLaunchForm ?
                                                        null
                                                        :
                                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "100px", "justify-content": "end" }}>
                                                            <Box sx={{ display: "flex" }}>
                                                                {row?.status === "pending" ?
                                                                    <Box pr="20px">
                                                                        <BootstrapTooltip title={`Restart`} placement="top">
                                                                            <Restart style={{ cursor: "pointer" }} onClick={() => openConfirmRestart(row?.serial)} />
                                                                        </BootstrapTooltip>
                                                                    </Box>
                                                                    :
                                                                    null
                                                                }
                                                                <Box pr="20px">
                                                                    {row?.status === "deleted" ?
                                                                        null
                                                                        :
                                                                        <BootstrapTooltip title={`Edit`} placement="top">
                                                                            <EditIcon style={{ cursor: "pointer" }} onClick={() => { clickLink(`/admin/calibration-session/edit/${competencyFormSelectValue}/${row?.serial}`) }} />
                                                                        </BootstrapTooltip>
                                                                    }
                                                                </Box>
                                                                {row?.status === "deleted" ?
                                                                    // <Box >
                                                                    //     <DeleteIcon style={{ opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }} />
                                                                    // </Box>
                                                                    null
                                                                    :
                                                                    <Box >
                                                                        <BootstrapTooltip title={`Delete`} placement="top">
                                                                            <DeleteIcon style={{ cursor: "pointer" }} onClick={(e) => { handleDeleteClick(e, row?.serial, row?.name) }} />
                                                                        </BootstrapTooltip>
                                                                    </Box>
                                                                }
                                                            </Box>
                                                        </Box>
                                                    }
                                                </Box>
                                            </Box>
                                            <Divider width="100%" />
                                        </Box>
                                    ))
                                        :
                                        <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "500px" }}>
                                            <Nodata />
                                            <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                {t('label.noData')}
                                            </Typography>
                                            {/* <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                                                {t('label.tryChangingFilter')}
                                            </Typography> */}
                                        </Box>
                                    }
                                </Paper>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container mt={1} spacing={2} >
                        <Grid item xs sm md display="flex" alignItems="center">
                            <Box mr={1}>
                                <Typography variant="s14_fw400">{t('label.showMaxItems')}</Typography>
                            </Box>
                            <Select
                                id="pagination"
                                variant="outlined"
                                defaultValue={10}
                                value={perPage}
                                onChange={handlePerPageChange}
                                displayEmpty
                                size="small"
                                className="white-bg"
                            >
                                <MenuItem value={10}>
                                    <Typography style={{ fontWeight: "300" }}>10</Typography>
                                </MenuItem>
                                <MenuItem value={20}>
                                    <Typography style={{ fontWeight: "300" }}>20</Typography>
                                </MenuItem>
                                <MenuItem value={30}>
                                    <Typography style={{ fontWeight: "300" }}>30</Typography>
                                </MenuItem>
                            </Select>
                        </Grid>
                        <Grid item display="flex" alignItems="center" ml="auto">
                            <Typography variant="s14_fw400">
                                {t('label.page')} {currentPage} {t('label.of')} {totalPage}
                            </Typography>
                        </Grid>
                        <Grid item ml="auto" display="flex" alignItems="center">
                            <CustomPagination
                                setCurrentPage={handleSetCurrentPage}
                                selected={currentPage}
                                count={totalPage}
                            ></CustomPagination>
                        </Grid>
                    </Grid>
                    <SimpleDialog
                        open={isSuccessDeleteDialogOpen}
                        setValue={openSuccessDeleteDialog}
                        text={t(`admin.label.calibrationSessionDeletedSuccessfully`)}
                    />
                    <SimpleDialog
                        open={isSuccessLaunchFor}
                        doDirect={() => closeSuccess()}
                        setValue={openSuccessDeleteDialog}
                        text={`${selected.length} calibration sessions was launched successfully`}
                        page={true}
                    />
                    <ConfirmDialog
                        open={isConfirmLaunchFormDialogOpen}
                        warning={true}
                        doConfirm={launchForm}
                        setValue={e => setConfirmLaunchFormDialogOpen(false)}
                        title="Confirmation of Launch Calibration Session"
                        text={`Are you sure to launch ${selected.length} calibration sessions ?`}
                    />
                    <ConfirmDialog
                        open={isRestartDialogOpen}
                        warning={true}
                        doConfirm={reStartForm}
                        setValue={e => setConfirmRestartDialogOpen(false)}
                        title="Confirmation of restart workflow"
                        text={`Are you sure to restart workflow to In Progress?`}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={t(`admin.label.calibrationSessionDeletedFail`)}
                    />
                    <MessageDialog
                        open={openFailedLaunchMessageDialog}
                        setValue={handleCloseFailedLaunchMessageDialog}
                        type="fail"
                        twoline={true}
                        title={t(`admin.label.launchCalibrationSessionFailed`)}
                        text={t(`admin.label.launchCalibrationSessionFailedDetail`)}
                    />
                    <ConfirmDialog
                        open={isConfirmDeleteDialogOpen}
                        trash={true}
                        doConfirm={handleConfirmDeleteList}
                        setValue={handleConfirmDeleteDialog}
                        title={t('label.confirmationofDeletion')}
                        text={language === "en-US" ? t('admin.label.confirmDeleteCalibrationSessionText') + " “" + nameDel + "” ?" : t('admin.label.confirmDeleteCalibrationSessionText') + " “" + nameDel + "” หรือไม่ ?"}
                    />
                </Container>
            </Box>
        </Box >
    );
};
export default CalibrationSession;
